<template>
<div class="filter-wrapper" :class="{disabled: disableElement}">
  <div class="filters-section">
   <div class="search" :style="{'margin-bottom': !showFilterOptions ? 0 : null}">
     <div class="header-wrap">
        <h2>Voorspelling</h2>
        <i class="icon-wrap" v-if="showFilterToggle" @click="showFilterOptions = !showFilterOptions"
        :class="{
          'arrow-up': !showFilterOptions,
          'arrow-down': showFilterOptions,
        }"
      ></i>
        </div>
         <input type="text" placeholder="Zoek op N-weg"
            @blur="onBlur"
            @focus="onFocus"
            @keyup.arrow-down="onFocus"
            @keyup.escape="resetFilteredPredictions"
            :class="{shadow: !showAutoSuggest}"
            v-model="selection"
            v-show="showFilterOptions"
            ref="traject"
         >
         <span v-if="selection" class="clear-search" @click="selection = '' && onChange()"> x</span>
         <ul v-if="showAutoSuggest" ref="autosuggest">
            <li
              v-for="(prediction, index) in getPredictions"
              :key="index"
              :class='{active: currentItem === index}'
              :data-beheer_object="prediction.properties.beheer_object"
              @click="selectOption(prediction.properties.beheer_object)"
            >
              {{ prediction.properties.beheer_object }}
            </li>
         </ul>
    </div>
    <div class="slider-header">
      <span>Verleden</span>
      <span>Toekomst</span>
    </div>
    <div class="slider" v-show="showFilterOptions">
      <vue-slider v-model.number="value" v-bind="options" :marks="marks" @click.native="filterPredictions('year', value)" :silent="true"></vue-slider>
    </div>
    <div class="object-section" v-show="showFilterOptions">
      <ul>
        <li v-for="(type, index) in objectTypes" :key="index">
          <span v-if ="selectedObjects && selectedObjects.includes(type)" class="checkedBox" @click="filterPredictions('objectType')"></span>
          <span v-else class="notCheckedBox" @click="filterPredictions('objectType', type)"></span>
          <span class="filterName">{{type}}</span>
        </li>
      </ul>
    </div>
    <div class="checkboxes" v-show="showFilterOptions">
      <PzhCheckbox id="tracking" label="Spoorvorming" :value="true" :disabled="true"></PzhCheckbox>
      <!-- <PzhCheckbox id="tracking" label="Spoorvorming" :value="filters.tracking || filters.tracking == 'true' ? true : false"></PzhCheckbox> -->
      <!-- <PzhCheckbox id="iri" label="IRI" :value="filters.iri || filters.iri == 'true' ? true : false" @onUpdate="onCheck" disabled></PzhCheckbox> -->
    </div>
  </div>
</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Loader from '@/components/Loader'
import PzhCheckbox from '@/components/Checkbox'
import vueSlider from 'vue-slider-component'

export default {
  props: {
    objectTypes: {
      type: Array,
      required: true
    },
    trajects: {
      type: Array,
      required: true
    },
    disableElement: {
      type: Boolean
    }
  },
  data () {
    return {
      currentItem: -1,
      componentKey: 0,
      showAutoSuggest: false,
      value: new Date().getFullYear(),
      marks: [],
      options: {
        railStyle: {
          'borderRadius': '2.5px',
          'backgroundColor': '#000066'
        }
      },
      showFilterToggle: false,
      showFilterOptions: true
    }
  },
  components: {
    Loader,
    PzhCheckbox,
    vueSlider
  },
  created () {
    this.filters.year = this.value
    this.$emit('set-filter', this.filters)

    this.options.min = this.value - 3
    this.options.max = this.value + 4

    this.marks = [this.options.min, this.options.max]

    document.addEventListener('keyup', this.nextItem)
  },
  mounted () {
    const vueSliderDot = this.$el.querySelector('.vue-slider-dot')
    const markerLabels = this.$el.querySelectorAll('.vue-slider-mark-label')

    vueSliderDot.style.width = '20px'
    vueSliderDot.style.height = '20px'
    vueSliderDot.style.borderRadius = '50%'
    vueSliderDot.style.backgroundColor = '#fff'
    vueSliderDot.style.boxShadow = '0 2px 4px 0 rgba(22,56,113,0.3)'

    markerLabels[0].style.color = '#222'
    markerLabels[0].style.marginLeft = '1em'
    markerLabels[0].style.marginTop = '-2em'

    markerLabels[1].style.color = '#222'
    markerLabels[1].style.marginTop = '-2em'
    markerLabels[1].style.transform = 'translateX(-100%)'

    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.nextItem)
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    selection: function () {
      this.onChange()
    },
    getPredictions: function (predictions) {
      this.showAutoSuggest = false
      if (predictions && predictions.length) {
        this.showAutoSuggest = predictions.length === 1 ? this.getPredictions[0].properties.beheer_object.toLowerCase() !== this.selection.toLowerCase() : true
      }
    }
  },
  computed: {
    selectedObjects () {
      if (this.filters.hasOwnProperty('objectType')) {
        return this.filters['objectType']
      }
    },
    selection: {
      get () {
        return this.selectedFilter
      },
      set (value) {
        this.$store.commit('projects/setSelectedFilter', value)
      }
    },
    ...mapState('projects', ['objectType', 'filters', 'selectedFilter']),
    ...mapGetters(['getPredictions'])
  },
  methods: {
    onFocus () {
      let filterUpdate = this.filters
      if (!this.selection) {
        filterUpdate.nway = null

        this.$emit('set-filter', filterUpdate)
      }
    },
    onBlur () {
      if (!this.selection) {
        setTimeout(() => {
          this.showAutoSuggest = false
        }, 150)
      }
    },
    onChange () {
      let filterUpdate = this.filters

      this.selection ? filterUpdate['nway'] = this.selection : delete filterUpdate['nway']
      if (this.selection) {
        filterUpdate['nway'] = this.selection
      } else {
        delete filterUpdate['nway']

        this.resetFilteredPredictions()
      }

      this.$emit('set-filter', filterUpdate)
    },
    onCheck ($event) {
      let filterUpdate = this.filters

      filterUpdate[$event.target.id] = $event.target.checked

      this.$emit('set-filter', filterUpdate)
    },
    onResize () {
      this.showFilterToggle = this.$el.clientWidth <= 768
      if (!this.showFilterToggle) {
        this.showFilterOptions = true
      }
    },
    selectOption (nway) {
      this.selection = nway
      this.resetFilteredPredictions()
    },
    nextItem (event) {
      if (!this.showAutoSuggest) return

      event.preventDefault()

      const totalItems = this.getPredictions.length - 1
      if (event.code === 'ArrowUp') {
        this.currentItem > 0 ? this.currentItem-- : this.currentItem = totalItems
      } else if (event.code === 'ArrowDown') {
        this.currentItem < totalItems ? this.currentItem++ : this.currentItem = 0
      }

      setTimeout(() => {
        const activeLi = this.$refs['autosuggest'].querySelector('.active')
        if (activeLi) {
          if (event.code === 'Enter') {
            this.selectOption(activeLi.getAttribute('data-beheer_object'))
          } else {
            activeLi.scrollIntoView(this.currentItem > 0 && this.currentItem < totalItems ? {behavior: 'smooth'} : '')
          }
        }
      })
    },
    filterPredictions (filterType, filterVal) {
      let filterUpdate = this.filters
      filterUpdate[filterType] = filterVal
      this.$emit('set-filter', filterUpdate)
    },
    resetFilteredPredictions () {
      this.currentItem = -1
      this.$store.dispatch('setPredictions', [])
    },
    resetFilter () {
      let getFilters = this.filters
      Object.keys(getFilters).forEach(key => delete getFilters[key])
      this.value = new Date().getFullYear()
      this.$emit('set-filter', getFilters)
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../sass/variables'

.filter-wrapper
  position: absolute
  left: 0
  right: 0
  margin: auto
  background: $white
  flex-direction: column
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2)
  z-index: 1000
  width: 1170px
  max-width: 90%
  top: 0
  @media screen and (max-width: $lg-breakpoint)
    left: 5.5em

.slider-header
  color: #222
  display: flex
  justify-content: space-between

.slider
  margin-top: 1.9em
  .label
    font-size: 15px
    padding-bottom: 8px
    display: block
.filters-section
  width: 360px
  position: absolute
  left: -0.8em
  top: 2.5em
  background: $white
  flex-direction: column
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2)
  padding: 2em
  @media screen and (max-width: $md-breakpoint)
    width: 328px
    top: 0.8em
  .search
    margin-bottom: 2em
    position: relative
    .header-wrap
      display: flex
      justify-content: space-between
    input::-ms-clear
      display: none
    .clear-search
      position: absolute
      top: 3em
      right: 0.2em
      font-size: 1.5em
      line-height: 0.5em
      cursor: pointer
      color: $blue
      &:hover
        color: #B01C32
    ul
      margin-left: 2px
      padding: 0.5em 0
      overflow-x: hidden
      overflow-y: auto
      max-height: 8em
      box-shadow: -2px 2px 5px 0 rgba(83,147,255,0.5)
      transition: 0.2s all ease
      padding-left: 0.8em
      li
        color: $blue
        background: white
        cursor: pointer
        width: 100%
        padding: 0 0.6em
        line-height: 2em
        font-size: 0.9em
        font-weight: bold
        &:hover, &.active
          color: #B01C32
  h2
      color: $blue
      font-size: 1.5em
      margin-bottom: 1em
  input
    box-sizing: border-box
    width: 100%
    background: $white
    border: 1px solid $blue
    height: 2.5em
    padding: 0 1.250em 0 1.250em
    font-size: 1em
  .object-section
    display: flex
    clear: left
    ul
      margin-top: 2.8em
      li
        color: $blue
        font-size: 1em
        font-weight: bold
        display: flex
        align-items: center
        margin-bottom: 1.250em
        span
          cursor: pointer
        span.notCheckedBox
          background-image: url('../assets/images/box-empty.svg')
          background-size: 2em
          transition: 0.4s
          width: 2em
          height: 2em
          background-repeat: no-repeat
          box-shadow: -2px 2px 5px 0 rgba(83,147,255,0.5)
          &:hover
            background-image: url('../assets/images/box-empty-hover.svg')
        span.checkedBox
          background-image: url('../assets/images/box-ticked.svg')
          background-size: 2em
          width: 2em
          height: 2em
          background-repeat: no-repeat
          box-shadow: -2px 2px 5px 0 rgba(83,147,255,0.5)
          &:hover
            background-image: url('../assets/images/box-ticked-hover.svg')
        span.filterName
          padding-left: 1.2em
  .clearYear
    color: $blue
    font-size: 14px
    margin: 1em 0 1.8em 0
    background-color: $grey
    line-height: 2.2em
    display: flex
    align-items: center
    justify-content: center
    max-width: 10em
    cursor: pointer
    &:after
      content: ''
      background-image: url('../assets/images/delete-x.svg')
      width: 1em
      height: 1em
      background-repeat: no-repeat
      background-position: center
      background-size: auto
      margin-left: 0.4em

  .checkboxes
    display: flex
    .checkbox-wrap:last-of-type
      // margin-left: 2em
</style>
<style lang="sass">
@import '../sass/variables'
label[for="tracking"]
  opacity: 1
  color: $blue !important
</style>



// WEBPACK FOOTER //
// src/components/Filters.vue